import { arrayMap } from "../../../utils/array.utils";
import { DoneIcon } from "../../../utils/icon.utils";

export default function StepTimeline({ step }) {
  // Array of step labels
  const steps = [
    {
      id: 1,
      name: "Vehicle"
    },
    {
      id: 2,
      name: "Inventory"
    }
  ];

  const activeColor = `var(--primary-btn-color)`;

  return (
    <div className="d-flex align-items-center justify-content-center mb-5">
      {arrayMap(steps, (item, index) => {
        const isActive = index < step.currentStep;
        return (
          <div key={item.id} className="d-flex align-items-center">
            <div
              style={{
                height: 40,
                width: 40,
                backgroundColor: isActive ? activeColor : `#ddd`,
                color: isActive ? `#fff` : `#000`,
                fontWeight: 500,
                border: `1px solid ${isActive ? activeColor : `#000`}`
              }}
              className="rounded-circle d-flex align-items-center justify-content-center position-relative">
              {isActive ? <DoneIcon /> : item.id}

              <div
                className="position-absolute text-center"
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  top: 40,
                  color: isActive ? activeColor : `#000`
                }}>
                {item.name}
              </div>
            </div>
            {index < steps.length - 1 && (
              <div
                style={{
                  width: 80,
                  borderBottom: `2px solid ${index < step.currentStep - 1 ? activeColor : `#000`}`
                }}></div>
            )}
          </div>
        );
      })}
    </div>
  );
}
